"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeRegistry__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
        ],
        name: "AddProvider",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
        ],
        name: "RemoveProvider",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "provider",
                type: "address",
            },
        ],
        name: "addProvider",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "listProviders",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "provider",
                type: "address",
            },
        ],
        name: "removeProvider",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class BridgeRegistry__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BridgeRegistry__factory = BridgeRegistry__factory;
BridgeRegistry__factory.bytecode = _bytecode;
BridgeRegistry__factory.abi = _abi;
//# sourceMappingURL=BridgeRegistry__factory.js.map